<div class="page-layout">
    <form class="f-col blank-form" [formGroup]="changePasswordForm"
        (ngSubmit)="updatePassword()">
        <div class="section-heading">
            <h2 class="h2-heading">{{content?.['b2b.managetraveler.changepassword']}} <div class="dot">.</div> <span
                    class="optional">{{content?.['b2b.managetraveler.optional']}}</span>
            </h2>
        </div>
        <div class="section-content" *ngIf="!isPasswordUpdated" [class.view-disabled]="isProfileViewRestricted">
            <div class="inner-contentsection">
                <div class="f-row">
                    <div class="f-col">
                        <mat-form-field appearance="fill">
                            <mat-label>
                                {{content?.['b2b.managetraveler.newpassword']}}
                            </mat-label>
                            <input matInput [placeholder]="content?.['b2b.managetraveler.newpassword']"
                                [type]="showNewPassword?'text':'password'" formControlName="password">
                            <button mat-icon-button matSuffix aria-label="Toggle password visibility" type="button"
                                (click)="showNewPassword = !showNewPassword">

                                <mat-icon fontSet="material-symbols-outlined">
                                    {{ (showNewPassword) ? "visibility" : "visibility_off" }}
                                </mat-icon>
                            </button>

                            <mat-error
                                *ngIf="changePasswordForm.get('password')?.hasError('required') && changePasswordForm.get('password')?.touched">
                                {{content?.dictionary?.['b2b.register.passwordreq']}}
                            </mat-error>
                            <mat-error
                                *ngIf="changePasswordForm.get('password')?.hasError('maxlength') && changePasswordForm.get('password')?.touched">
                                {{content?.dictionary?.['b2b.register.cannotexceedpassword']}} </mat-error>

                        </mat-form-field>
                    </div>
                </div>

                <div class="f-row">
                    <div class="f-col">
                        <mat-form-field appearance="fill">
                            <mat-label>{{content?.['b2b.managetraveler.confirmnewpassword']}}</mat-label>
                            <input matInput [placeholder]="content?.['b2b.managetraveler.confirmnewpassword']" type="password"
                                formControlName="confirmPassword" [type]="showConfirmPassword ? 'text':'password' ">
                            <button mat-icon-button matSuffix aria-label="Toggle password visibility"
                                 (click)="showConfirmPassword=!showConfirmPassword" type="button">

                                <mat-icon fontSet="material-symbols-outlined">
                                    {{ (showConfirmPassword) ? "visibility" : "visibility_off" }}
                                </mat-icon>
                            </button>

                            <mat-error *ngIf="changePasswordForm.get('confirmPassword')?.hasError('passwordMismatch') && changePasswordForm.get('confirmPassword')?.touched">
                                {{ content?.dictionary?.['b2b.global.passwordnotmatch'] || 'Passwords do not match. Please try again.' }} </mat-error>
                            <mat-error
                                *ngIf="changePasswordForm.get('confirmPassword')?.hasError('required')&& changePasswordForm.get('confirmPassword')?.touched">
                               {{content?.dictionary?.['b2b.register.passwordcriteria']}}  </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="toast-container toast-msg__info-med">
                <div class="toast-wrapper">
                    <div class="f-row toaster-value-row d-align-left">
                        <div class="toast-icon">
                            <mat-icon fontSet="material-symbols-outlined" class="mat-icon"> info </mat-icon>
                        </div>

                        <div class="toast-content">
                            <div class="toast-desc">
                                <p>{{content?.toastMessageList[4]?.description}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <mat-error *ngIf="changePasswordForm.get('password')?.hasError('pattern')" [innerHTML]="content?.dictionary?.['b2b.register.passwordcriteria'].replaceAll('\n','<br>')">
                 <!-- Password should have:
                <ul>
                    <li>8 or more characters</li>
                    <li>At least 1 uppercase letter</li>
                    <li>At least 1 lowercase letter</li>
                    <li>At least 1 numeric character</li>
                    <li>At least 1 special character</li>
                </ul> -->
            </mat-error>
            <div class="inner-action">
                <button mat-button class="button--secondary-small"
                    type="button" (click)="onCancel()">{{content?.['b2b.managetraveler.cancel']}}</button>
                <button mat-button type="submit" class="button--primary-small" [class.disabled]="isSpinner || changePasswordForm.invalid">
                    <mat-spinner class="button"
                        *ngIf="isSpinner"></mat-spinner>{{content?.['b2b.managetraveler.save']}}</button>
            </div>
        </div>

        <div *ngIf="isPasswordUpdated" class="f-row">
            <div class="f-col">
                <mat-form-field appearance="fill">
                    <mat-label>{{content?.['b2b.managetraveler.efpassword'] || 'Password'}}</mat-label>
                    <input matInput [value]="updatedPassword" type="password" readonly  />
                </mat-form-field>
            </div>
        </div>
    </form>

    
</div>